export default __webpack_public_path__ + "static/media/ey_black_footer.ff85951d.png";